import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

type UpdateEventSessionsRegistrationLimitInput = {
  eventId: number;
  limitRegistration: boolean;
};

const UPDATE_SESSION_REGISTRATION_LIMIT_MUTATION = gql`
  mutation UpdateEventSessionsRegistrationLimit(
    $input: UpdateEventSessionsRegistrationLimitInput!
  ) {
    updateEventSessionsRegistrationLimit(input: $input) {
      ok
      event {
        id
      }
    }
  }
`;

const eventSessionsRegistrationLimitApi = {
  update: (input: UpdateEventSessionsRegistrationLimitInput): Promise<{ ok: boolean }> => {
    return gqlClient
      .request<{ updateEventSessionsRegistrationLimit: { ok: boolean } }>(
        UPDATE_SESSION_REGISTRATION_LIMIT_MUTATION,
        {
          input
        }
      )
      .then((res) => res.updateEventSessionsRegistrationLimit);
  }
};

export { eventSessionsRegistrationLimitApi };
